<template>
  <v-row justify="center">
    <v-dialog v-model="show" max-width="600px" persistent>
      <v-card>
        <v-card-title style="justify-content: center;">{{ $t('terminal.title') }}</v-card-title>
        <v-card-subtitle class="pb-0" style="text-align: center;">
          {{ $t('terminal.introductionSentence') }}
        </v-card-subtitle>
        <v-card-text>
          <Validation-observer ref="form">
            <v-form id="terminalForm" @submit.prevent="validateTerminal">
              <validation-provider v-slot="{errors}" :name="$t('terminal.select')"
                                   :rules="terminals.length ? 'required' : ''">
                <v-select
                    v-model="selectedTerminal"
                    :error-messages="errors"
                    :items="terminals"
                    :loading="loadingTerminals"
                    :placeholder="$t('terminal.select')"
                    :no-data-text="$t('terminal.noTerminal')"
                    item-text="terminal_id"
                    item-value="terminal_id"
                    required
                />
              </validation-provider>
            </v-form>
          </Validation-observer>
          <v-radio-group v-if="testMode" v-model="refundTypeTest">
            <v-radio
                :label="$t('refund.simulateSuccess')"
                value="success"
            ></v-radio>
            <v-radio
                :label="$t('refund.simulateError')"
                value="error"
            ></v-radio>
          </v-radio-group>
        </v-card-text>
        <v-card-actions class="pa-0">
          <v-btn
              :disabled="loadingTerminals ||!this.terminals.length"
              color="primary"
              form="terminalForm"
              style="width: 50%"
              tile
              type="submit"
          >
            {{ $t('terminal.validate') }}
          </v-btn>
          <v-btn
              :disabled="loadingTerminals"
              class="ml-0"
              color="secondary"
              style="width: 50%"
              tile
              @click="close">
            {{ $t('terminal.cancel') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { EventBus } from '../../event-bus'
import { ValidationObserver, ValidationProvider } from 'vee-validate'

export default {
  name: 'TerminalSelectionDialog',
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data () {
    return {
      terminals: [],
      selectedTerminal: undefined,
      refundTypeTest: 'success',
      loadingTerminals: false
    }
  },
  mounted () {
    this.getTerminals()
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    testMode: {
      type: Boolean,
      default: false
    },
    currentStore: {
      type: Object
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    getTerminals () {
      this.loadingTerminals = true
      if (this.testMode) {
        this.terminals = [{ terminal_id: 'terminal_1' }, { terminal_id: 'terminal_2' }]
        this.loadingTerminals = false
      } else {
        let locationId
        if (this.currentStore) {
          locationId = this.currentStore.location_id
        }
        let myInit = {
          headers: {
            Authorization: 'Bearer ' + this.$auth.accessToken
          }
        }

        if (locationId) {
          myInit.queryStringParameters = {
            location_id: locationId
          }
        }

        this.$Amplify.API.get('payment', '/terminals', myInit).then((res) => {
          this.terminals = res
          this.loadingTerminals = false
        }).catch((e) => {
          console.log(e)
          EventBus.$emit('displaySnackbar', {
            display: true,
            text: this.$t('terminal.terminalsError'),
            color: 'error'
          })
          this.loadingTerminals = false
        })
      }
    },
    async validateTerminal () {
      const success = await this.$refs.form.validate()
      if (success) {
        this.$emit('refund', {
          selectedTerminal: this.selectedTerminal,
          refundTypeTest: this.testMode ? this.refundTypeTest : undefined
        })
      }
    },
    close () {
      this.$emit('closeTerminalDialog')
    }
  }
}
</script>
